export const Internship = () => {
  return <>
    <h1>R&D stageplaats</h1>
    <p>
      Hexagon is een wereldleider in digitale-realiteitsoplossingen, die sensor-, software- en autonome technologieën
      combineert. <br/>
      Het Luciad R&D team in Leuven ontwikkelt innovatieve software voor het visualizeren, analyzeren en beheren van
      geospatiale data, zoals satellietbeelden, real-time lucht- en scheepvaartverkeer, weerdata en 3D modellen van
      gebouwen en steden. <br/>
      Het combineren van state-of-the-art software & computer graphics technologieën biedt klanten zoals Airbus,
      Lufthansa Systems of BASF de mogelijkheid om grote hoeveelheden data in real-time om te zetten in uiterst
      performante visuele analyses. <br/>
      De software wordt tevens ingezet voor de realisatie van Smart Cities met behulp van een zogenaamde Digital Twin:
      met sensoren van Hexagon wordt een volledig digitale versie van een stad in 3D gecreëerd die op een visueel
      interactieve manier ingezet kan worden om beslissingen te nemen.
    </p>
    <h2>Interesse in een stage?</h2>
    <p>Het R&D team in Leuven zit aan de bron van het Luciad portfolio, een verzameling van producten specifiek gericht
      op ontwikkelaars van geospatiale visualisatie-oplossingen. <br/>
      Met een team van 30+ mensen werken we dagelijks aan innovatieve software somponenten ter ondersteuning van nieuwe
      mogelijkheden in diverse domeinen.</p>
    <p>
      Enkele vraagstukken die we recent hebben onderzocht:
      <ul>
        <li>Ontwikkel een oplossing die 3D puntenwolken met miljarden punten kan streamen naar webtoepassingen in de
          browser.
        </li>
        <li>Onderzoek het gebruik van augmented en virtual reality voor het verbeteren van luchtverkeersleiding.</li>
        <li>Visualizeer hoge-resolutie radar data in real-time.</li>
      </ul>
    </p>
    <p>
      Onze software wordt in verschillende programmeertalen ontwikkeld, waaronder Java, C++, JavaScript / TypeScript en
      C#. <br/>
      De software richt zich zowel op desktop, web en mobiele applicaties als op servertoepassingen, en steunt daarbij
      op een uitgebreide tech stack: WebGL, React, HTML 5, CSS 3, Android, Qt, JavaFX, Spring, RESTful web services, AWS
      / S3, SQL, ... <br/>
      In een agile softwareomgeving, waar verandering constant is, besteden we veel aandacht aan kwaliteitsvolle code
      waarbij we eigenschappen als leesbaarheid, aanpasbaarheid en onderhoudbaarheid van code hoog in het vaandel
      dragen.
    </p>
    <p>
      Op basis van je ervaring en interesse en de gewenste duurtijd kunnen we een gepast onderwerp binnen een van onze
      technologieën. <br/>
      We verwelkomen je graag in onze kantoren aan de Gaston Geenslaan 11 in Leuven, maar je hebt ook de
      nodige flexibiliteit om van thuis te werken.
    </p>
    <p>
      Interesse? Stuur dan een mail met je CV naar <a
        href="mailto:jobs.luciad.gsp@hexagon.com">jobs.luciad.gsp@hexagon.com</a>.
    </p>
  </>
}